// Shim over @symbo.ls/sdk-bridge. This module used to own the Supabase
// client directly; it now re-exports from the federation layer so
// every existing import (getSupabase / getSupabaseAsync / SUPABASE_URL /
// SUPABASE_ANON_KEY) keeps working unchanged while the underlying
// client, session state, and new federation APIs live in sdk-bridge.
//
// New code should import from '../governanceBridge.js' directly — or, for
// governance-specific work, use `getClient(PROJECT_GOVERNANCE)`.

import {
  getSupabase,
  getSupabaseAsync,
  getRealtimeSupabase,
  getProjectConfig,
  PROJECT_GOVERNANCE
} from '../governanceBridge.js'
import { createClient } from '@supabase/supabase-js'

const _cfg = getProjectConfig(PROJECT_GOVERNANCE)

// Preserve the legacy constant exports. Anything pinned to these values
// (e.g. edge-function URLs built from SUPABASE_URL) keeps working.
export const SUPABASE_URL = _cfg.url
export const SUPABASE_KEY = _cfg.anonKey
export const SUPABASE_ANON_KEY = _cfg.anonJwt

export { getSupabase, getSupabaseAsync, getRealtimeSupabase, createClient }
